import { render, staticRenderFns } from "./areaSelectDialog.vue?vue&type=template&id=7ed72670&"
import script from "./areaSelectDialog.vue?vue&type=script&lang=js&"
export * from "./areaSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/items/areaSelectDialog.vue"
export default component.exports